import './Dates.css';

export const Dates = () => (
  <div className='info--dates-container'>
    <span className='info--dates-title'>
      Сентябрь
    </span>

    <table className='info--dates-table'>
      <thead>
        <tr>
          <th className='info--dates-header-cell'>воскресенье</th>
          <th className='info--dates-header-cell'>понедельник</th>
          <th className='info--dates-header-cell'>вторник</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td className='info--dates-body-cell'>14</td>
          <td className='info--dates-body-cell'>
            15
            <div className='info--dates-circle-container'>
              <img
                className='info--dates-circle'
                src="/images/dates-circle.svg"
                alt=""
              />
          </div>
          </td>
          <td className='info--dates-body-cell'>16</td>
        </tr>
      </tbody>
    </table>
  </div>
)

